import type { AnalyticsValue } from '../types';

export const formatValue = (value: AnalyticsValue) => {
  if (!value) {
    return undefined;
  }

  if (Array.isArray(value)) {
    return value.join('|');
  }

  return value.toString();
};
